import { AdminLayout, catchError } from "@opendash/core";
import { useNavigate, useParams } from "@opendash/router";
import { observer } from "mobx-react-lite";
import Parse, { Role } from "parse";
import * as React from "react";
import { useEffect, useState } from "react";
import { StepsExecute } from "../../features/schedules";
import { ScheduleImage } from "../../features/schedules/components/ScheduleImage";
import { Schedule_Execution } from "../../js/parsegenerated/Schedule_Execution";

export const ScheduleExecutionPage = observer(() => {
  const params = useParams();
  const navigate = useNavigate();
  const [schedule, setSchedule] = useState<Schedule_Execution>();
  const [userRoles, setUserRoles] = useState<Role[]>([]);

  useEffect(() => {
    const user = Parse.User.current();
    if (!user) return;

    const getScheduleExecution = async () => {
      const [scheduleExecutionError, scheduleExecution] = await catchError(
        new Parse.Query(Schedule_Execution)
          .include("origin")
          //@ts-ignore
          .include("origin.cron")
          .include("source")
          .get(params["id"]!)
      );

      if (scheduleExecutionError) {
        //Redirect when schedule execution is not found
        navigate("/openservice/schedule/overview");
        return;
      }

      setSchedule(scheduleExecution);

      const [filteredRolesError, filteredRoles] = await catchError(
        new Parse.Query(Role).filter(async (currentObject) => {
          const users = await currentObject.relation("users").query().find();
          return users.some((userobject) => {
            if (userobject.id === user.id) {
              return true;
            }
            return false;
          });
        })
      );

      setUserRoles(filteredRoles);
    };

    getScheduleExecution();
  }, []);

  return (
    <AdminLayout contentPadding>
      <ScheduleImage schedule={schedule} />
      <StepsExecute schedule={schedule} userroles={userRoles} />
    </AdminLayout>
  );
});
